import { useState, useEffect } from 'react';

export const LAPTOP_COMPACT_MIN = 1200;
export const LAPTOP_COMPACT_MAX = 1536;

export const isLaptopCompactViewport = () => {
  if (typeof window === 'undefined') return false;
  const width = window.innerWidth;
  return width >= LAPTOP_COMPACT_MIN && width <= LAPTOP_COMPACT_MAX;
};

const useLaptopCompact = () => {
  const [isLaptopCompact, setIsLaptopCompact] = useState(isLaptopCompactViewport);

  useEffect(() => {
    const handleResize = () => setIsLaptopCompact(isLaptopCompactViewport());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isLaptopCompact;
};

export default useLaptopCompact;
